<template>
    <auth-card-template>
        <card-auth>
            <h4 class="font-family-title font-weight-bold text-success text-center mb-6">Redefinição de senha</h4>

            <div v-show="errorMessage" class="alert alert-danger mb-6" v-html="errorMessage"></div>

            <div v-show="isVerificationSent" class="alert alert-success mb-6">
                E-mail enviado! Acesse sua caixa de entrada e confira a mensagem com os detalhes para
                redefinir sua senha.
            </div>

            <div v-if="hasResetToken">
                <form v-if="!isResetPasswordSuccess" @submit.prevent="$_recaptcha_verify(resetPassword)">
                    <form-group label="Nova senha" label-for="resetPassword" :error="formErrors.password">
                        <input type="password" id="resetPassword" class="form-control" maxlength="100" autocomplete="new-password" autofocus v-model="formData.password">
                        <popover-password target="resetPassword" minlength="8" hasletter hasnumber v-model="formData.password" />
                    </form-group>

                    <form-group label="Confirme sua senha" label-for="resetPasswordConfirm" :error="formErrors.passwordConfirm">
                        <input type="password" id="resetPasswordConfirm" class="form-control" maxlength="100" autocomplete="new-password" v-model="formData.passwordConfirm">
                    </form-group>

                    <div class="mt-6">
                        <button-form ref="btnResetPassword" type="submit" theme="success" class="btn-lg btn-block">Enviar</button-form>
                    </div>
                </form>

                <div v-else>
                    <div class="alert alert-success">
                        Tudo pronto! Agora você já pode acessar o painel da Hostoo usando sua nova senha.
                    </div>
                </div>
            </div>

            <div v-else>
                <form @submit.prevent="$_recaptcha_verify(sendVerification)">
                    <form-group label="E-mail" labelFor="resetEmail" :error="formErrors.email">
                        <input type="email" id="resetEmail" class="form-control" spellcheck="false" autocomplete="email" autofocus v-model="formData.email">
                    </form-group>

                    <div class="mt-6">
                        <button-form ref="btnSendVerification" type="submit" theme="success" class="btn-lg btn-block">Enviar</button-form>
                    </div>
                </form>
            </div>

            <vue-recaptcha
                v-if="recaptchaKey"
                ref="recaptcha"
                size="invisible"
                :sitekey="recaptchaKey"
                :loadRecaptchaScript="true"
                @verify="$_recaptcha_onVerified"
                @expired="$_recaptcha_onExpired" />

            <div class="text-center mt-6">
                <template v-if="hasResetToken">
                    Deseja voltar para a tela de login?<br>
                    <router-link to="/auth/login" class="text-lg font-weight-semibold">Clique aqui</router-link>
                </template>
                <template v-else>
                    Ainda não possui uma conta?<br>
                    <router-link to="/auth/register" class="text-lg font-weight-semibold">Cadastre-se agora!</router-link>
                </template>
            </div>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import { mapActions }   from 'vuex'
    import VueRecaptcha     from 'vue-recaptcha'
    import recaptcha        from '@/mixins/recaptcha'
    import ErrorService     from '@/services/error.service'
    import ButtonForm       from '@/components/atoms/ButtonForm'
    import PopoverPassword  from '@/components/atoms/PopoverPassword'
    import FormGroup        from '@/components/molecules/FormGroup'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'

    export default {
        mixins: [recaptcha],
        components: {
            PopoverPassword,
            ButtonForm,
            VueRecaptcha,
            FormGroup,
            CardAuth,
            AuthCardTemplate
        },
        data() {
            return {
                recaptchaKey: '',
                resetToken: '',

                formData: {},
                formErrors: {},
                errorMessage: '',

                isVerificationSent: false,
                isResetPasswordSuccess: false
            }
        },
        computed: {
            hasResetToken: function () {
                return this.resetToken && this.resetToken.length > 0;
            }
        },
        created()
        {
            if (this.$route.query)
            {
                if (this.$route.query.token) {
                    this.resetToken = this.$route.query.token;
                }
                else if (this.$route.query.email) {
                    this.$set(this.formData, 'email', this.$route.query.email);
                }
            }
        },
        mounted()
        {
            this.recaptchaKey = this.$_recaptcha_siteKey;
        },
        methods: {
            ...mapActions({
                showErrorAlert: 'alert/error'
            }),

            /**
             * Solicitar redefinição de senha.
             */
            sendVerification()
            {
                this.formErrors = {};
                this.errorMessage = '';
                this.isVerificationSent = false;

                this.$refs.btnSendVerification.loadingFocus();

                const postData = Object.assign({}, this.formData);

                this.$api.post('/login/reset', postData)
                    .then(response => {
                        this.formData = {};
                        this.isVerificationSent = true;
                    })
                    .catch(error => {
                        ErrorService.handleAuthFormError(error, this, (message) => this.errorMessage = message);
                    })
                    .then(() => {
                        this.$refs.btnSendVerification.setLoading(false);
                        this.$refs.recaptcha.reset();
                    });
            },

            /**
             * Redefinir senha do usuário.
             */
            resetPassword()
            {
                this.formErrors = {};
                this.errorMessage = '';
                this.isResetPasswordSuccess = false;

                this.$refs.btnResetPassword.loadingFocus();

                const postData = Object.assign({ resetToken: this.resetToken }, this.formData);

                this.$api.post('/login/new-password', postData)
                    .then(response => {
                        this.formData = {};
                        this.isResetPasswordSuccess = true;
                    })
                    .catch(error => {
                        ErrorService.handleAuthFormError(error, this, (message) => this.errorMessage = message);
                    })
                    .then(() => {
                        this.$refs.btnResetPassword.setLoading(false);
                        this.$refs.recaptcha.reset();
                    });
            }
        }
    }
</script>